import { render, staticRenderFns } from "./choice-recalc-popup.vue?vue&type=template&id=b3efe25c&scoped=true&"
import script from "./choice-recalc-popup.vue?vue&type=script&lang=ts&"
export * from "./choice-recalc-popup.vue?vue&type=script&lang=ts&"
import style0 from "./choice-recalc-popup.vue?vue&type=style&index=0&id=b3efe25c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3efe25c",
  null
  
)

export default component.exports